import { render, staticRenderFns } from "./createEditDataset.vue?vue&type=template&id=2ec71ba8&scoped=true&"
import script from "./createEditDataset.vue?vue&type=script&lang=js&"
export * from "./createEditDataset.vue?vue&type=script&lang=js&"
import style0 from "./createEditDataset.vue?vue&type=style&index=0&id=2ec71ba8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec71ba8",
  null
  
)

export default component.exports